import type { CopyShape } from "@tami/core/intl";

import type { WORKFLOW_SCRIPT_COPY_PT_BR } from "../workflow-script.copy";

export const WORKFLOW_SCRIPT_COPY_EN_US: CopyShape<typeof WORKFLOW_SCRIPT_COPY_PT_BR> = {
  wfIntro: {
    narrative: "Organize your production workflow on a Kanban board — from idea to published content, without losing the thread.",
  },
  wfKanban: {
    narrative: "Each card shows platform, format and due date. Drag between columns to move the status forward.",
    callout: "Production Kanban: drag cards from draft all the way to published.",
  },
  wfOverview: {
    narrative: "See at once how many pieces are in idea, production, review or ready to go live.",
  },
  wfOutro: {
    narrative: "Your routine organized beyond the calendar — lists and workflow in one place.",
  },
};
